import { useAppNowUtc } from './appClock';
import { DateTime, DateTimeService, toDateTimeLuxon } from './dateTimes';

export const useRelativeDateTime = ({
    dateTime,
    locale,
    timezone,
}: {
    dateTime: DateTime;
    locale: string;
    timezone: string;
}) => {
    const nowUtc = useAppNowUtc();
    const base = toDateTimeLuxon(DateTimeService.fromUtc(nowUtc, timezone));
    return toDateTimeLuxon(dateTime).toRelative({ base, locale });
};
